export default __webpack_public_path__ + "static/media/kitchen3-after2-2048w.329cc7ad.avif";